import React from 'react';
import Relay from 'react-relay';

import IconButton from 'react-mdl/lib/IconButton';

import MailingListMemberRow from './MailingListMemberRow/MailingListMemberRow';

class MailingListMembers extends React.Component {
    componentWillMount() {
        this.setState({
            newMembers: [],
        })
    }

    addNewMember() {
        this.setState(({newMembers}) => ({
            // set the state with a new array instead of push so it updates the view
            newMembers: newMembers.concat([Math.random().toString()])
        }));
    }

    render() {
        let list = this.props.list;
        let members = list.members;

        return (
            <table className="mdl-data-table mdl-shadow--2dp" style={{margin: '2em auto 0'}}>
                <thead>
                <tr>
                    <th className="mdl-data-table__cell--non-numeric">
                        <div>
                            <span>Name</span>
                        </div>
                    </th>
                    <th className="mdl-data-table__cell--non-numeric">
                        <div>
                            <span>Address</span>
                        </div>
                    </th>
                    <th className="mdl-data-table__cell--non-numeric">
                        <div>
                            <span>Variables</span>
                        </div>
                    </th>
                    <th>
                        <div>
                            <IconButton name="refresh" onClick={() => this.props.reload()}/>
                            <IconButton name="add" onClick={() => this.addNewMember()}/>
                        </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                {members.map(member => <MailingListMemberRow key={`list-${list.address}-member-${member.address}`} member={member} />)}
                {this.state.newMembers.map((id) => <MailingListMemberRow key={'new-list-' + id} member={null}/>)}
                </tbody>
            </table>
        );
    }
}

export default Relay.createContainer(MailingListMembers, {
    fragments: {
        list: () => Relay.QL`
            fragment on MailingList {
                address
                members {
                    address
                    
                    ${MailingListMemberRow.getFragment('member')}
                }
            }
        `,
    }
});


/** WEBPACK FOOTER **
 ** ./src/Routes/MailingListDetails/MailingListMembers/MailingListMembers.js
 **/